/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getFile } from "actions";
import "components/widgets/training/TrainingDetailDocument.css";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import { Dropdown } from "react-bootstrap";
import { LANGUAGE_CODES } from "util/constant";

import { ReactComponent as UKFlag } from "components/widgets/language/flag-united-kingdom.svg";
import { ReactComponent as UAEFlag } from "components/widgets/language/flag-united-arab-emirates.svg";
import { ReactComponent as FRFlag } from "components/widgets/language/flag-france.svg";
import { ReactComponent as DEFlag } from "components/widgets/language/flag-germany.svg";
import { ReactComponent as RUFlag } from "components/widgets/language/flag-russia.svg";
import { ReactComponent as ESFlag } from "components/widgets/language/flag-spain.svg";
import { ReactComponent as TRFlag } from "components/widgets/language/flag-turkey.svg";
import { ReactComponent as HRFlag } from "components/widgets/language/flag-croatian.svg";

class TrainingDetailDocument extends Component {
  state = {
    document: { ...this.props.document },
    lang: this.props.document.languageVersions[0],
  };

  componentDidMount() {}

  showDetail = () => {
    if (this.state.lang.fileSource === "Dynamics") {
      this.props.getFile(
        this.state.lang.fileURL,
        () => {
          this.props.onProcessBegin();
        },
        (res, headers) => {
          this.props.onProcessEnd();
          this.viewOrDownload(URL.createObjectURL(res.raw.data), headers);
        },
        (e) => {
          this.props.onProcessEnd();
          console.dir(e);
        },
        false
      );
    } else {
      this.downloadExternalLink(this.state.lang.fileURL);
    }
  };

  viewOrDownload = (href, headers) => {
    let filename = "unknownfile";
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(headers["content-disposition"]);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }

    //download
    let a = window.document.createElement("a");
    a.setAttribute("href", href);
    a.setAttribute("target", "_blank");
    a.setAttribute("download", filename);
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  };

  downloadExternalLink = (link) => {
    let a = window.document.createElement("a");
    a.setAttribute("href", link);
    a.setAttribute("target", "_blank");
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  };

  getFlag = (languageCode) => {
    switch (languageCode) {
      case LANGUAGE_CODES.English:
        return <UKFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Arabic:
        return <UAEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.French:
        return <FRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.German:
        return <DEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Russian:
        return <RUFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Spanish:
        return <ESFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Turkish:
        return <TRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Croatian:
        return <HRFlag className="img-fluid flag" />;
      default:
        return null;
    }
  };

  renderLanguageVersions = () => {
    return (
      <Dropdown>
        <Dropdown.Toggle size="sm" variant="">
          {this.state.lang && (
            <React.Fragment>
              {this.getFlag(this.state.lang.languageCode.value)}{" "}
              {this.state.lang.languageCode.label}
            </React.Fragment>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {this.props.document.languageVersions.map((item) => (
            <Dropdown.Item
              key={item.languageCode.value}
              eventKey={item.languageCode.value}
              onSelect={(key, obj) => {
                this.setState({ lang: item });
              }}
            >
              {this.getFlag(item.languageCode.value)} {item.languageCode.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderDocument = () => {
    if (!this.state.lang) return null;

    return (
      <>
        <SvgViewDocuments
          onClick={() => this.showDetail()}
          className="training-table__icon-viewdoc"
        />
        <span>{this.state.lang.name}</span>
        {this.renderLanguageVersions()}
      </>
    );
  };

  render() {
    return (
      <div className="trdoc_doc">
        {this.props.spinner}
        {this.renderDocument()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    aplication: state.aplication,
  };
};

export default connect(mapStateToProps, {
  getFile,
})(containsLongRunningProcess(TrainingDetailDocument));
